import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Northvanta transformó por completo nuestra operación digital. La automatización del CRM nos ahorró cientos de horas mensuales y las ventas aumentaron un 40% en el primer trimestre.',
  author: 'Carlos Mendoza',
  role: 'Director de Operaciones, TechFlow'
}, {
  quote: 'Buscábamos una agencia que entendiera la tecnología a un nivel profundo. El equipo no solo rediseñó nuestra plataforma, sino que implementó una arquitectura escalable impecable.',
  author: 'Laura Silva',
  role: 'CEO, Innova Solutions'
}, {
  quote: 'El enfoque orientado a datos de sus estrategias de marketing marcó la diferencia. Pasamos de tener tráfico irrelevante a leads altamente cualificados en cuestión de semanas.',
  author: 'Andrés Vargas',
  role: 'CMO, FinTech Global'
}];
const logos = ['Acme Corp', 'GlobalTech', 'Nexus', 'Quantum', 'Stark Ind', 'Wayne Ent'];
export function TestimonialsSection() {
  return <section id="testimonios" className="py-24 relative z-10 bg-brand-dark/30" data-id="element-153">
      <div className="container mx-auto px-6 md:px-12" data-id="element-154">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-155">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-156">
            Confianza que genera{' '}
            <span className="text-brand-cyan" data-id="element-157">resultados</span>
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-158">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="glass-panel p-8 rounded-2xl border border-white/5 relative group hover:border-brand-cyan/20 transition-colors" data-id="element-159">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-brand-cyan/20 group-hover:text-brand-cyan/40 transition-colors" data-id="element-160" />
              <p className="text-gray-300 mb-8 relative z-10 leading-relaxed italic" data-id="element-161">
                "{testimonial.quote}"
              </p>
              <div data-id="element-162">
                <div className="font-semibold text-white" data-id="element-163">
                  {testimonial.author}
                </div>
                <div className="text-sm text-brand-cyan" data-id="element-164">
                  {testimonial.role}
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Logos Row */}
        <div className="border-t border-white/5 pt-12" data-id="element-165">
          <p className="text-center text-sm text-gray-500 uppercase tracking-widest mb-8" data-id="element-166">
            Empresas que confían en nosotros
          </p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-50 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-167">
            {logos.map((logo, index) => <div key={index} className="text-xl font-bold text-gray-400 font-mono tracking-tighter" data-id="element-168">
                {logo}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}